import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Svg from '../svgIcon';
import './styles.scss';

const generateLinkLogo = hideLogo => (
    !hideLogo ? (
        <span className="bs-bookmakerLogo bs-header__linkLogo"></span>
    ) : null
)

const generateTogglingLayer = toggle => (
    toggle ? (
        <div
            className="bs-header__togglingLayer"
            role="toolbar"
            onClick={toggle}
        >
        </div>
    ) : null
)

const PageHeader = ({ children, backLinkUrl, hideLogo, toggle }) => (
    <div className="bs-header">
        {
            backLinkUrl ? (
                <Link
                    className="bs-header__link"
                    to={{
                        pathname: backLinkUrl,
                        state: { isReversedAnimation: true },
                    }}
                >
                    <Svg
                        iconName="left"
                        size="Medium"
                        className="bs-header__linkIcon"
                    />
                    {generateLinkLogo(hideLogo)}
                </Link>
            ) : generateLinkLogo(hideLogo)
        }
        {children}
        {generateTogglingLayer(toggle)}
    </div>
);

PageHeader.defaultProps = {
    backLinkUrl: '',
    children: null,
    hideLogo: false,
    toggle: null,
};

PageHeader.propTypes = {
    backLinkUrl: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    hideLogo: PropTypes.bool,
    toggle: PropTypes.func,
};

export default PageHeader



// WEBPACK FOOTER //
// /src/js/common/pageHeader/PageHeader.jsx